import React, { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDropzone } from "react-dropzone";
import { Button } from "react-bootstrap";
import { messages } from "./messages";
import { Container, ButtonContainer, DropzoneContainer } from "./styles";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ExcelHandlerFormProps {
  isDisabled: boolean;
  onExport: (onFinish: () => void) => void;
  onImport: (data: any) => void;
}

export default function ExcelHandlerForm({ isDisabled = false, onImport, onExport }: ExcelHandlerFormProps) {

  const [file, setFile] = useState<File | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isImportExecuting, setImportExecuting] = useState<boolean>(false);
  const [isExportExecuting, setExportExecuting] = useState<boolean>(false);

  const handleImport = useCallback(async () => {
    setLoading(true);
    setImportExecuting(true);
    onImport(await file?.arrayBuffer());
  }, [file, onImport]);

  const handleExport = useCallback(() => {
    setLoading(true);
    setExportExecuting(true);
    onExport(() => {
      setLoading(false);
      setExportExecuting(false);
    });
  }, [onExport]);

  const onDrop = useCallback(<T extends File>(acceptedFiles: T[]) => {
    if (!acceptedFiles || acceptedFiles.length === 0) {
      return;
    }
    setFile(acceptedFiles[0]);
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    disabled: isDisabled,
    onDrop,
    accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return (
    <>
      <Container>
        <DropzoneContainer {...getRootProps()}>
          <input {...getInputProps()} />
          {file ? <div>{file.name}</div> : <FormattedMessage {...messages.dropHere} />}
        </DropzoneContainer>
      </Container>
      <ButtonContainer>
        <Button variant="primary" type="button" onClick={handleImport} disabled={isDisabled || isLoading}>
          {isImportExecuting ? <FontAwesomeIcon icon={faCircleNotch} spin /> : <FormattedMessage {...messages.import} />}
        </Button>
        <Button variant="primary" type="button" onClick={handleExport} disabled={isDisabled || isLoading} className="min-vw-30">
          {isExportExecuting ? <FontAwesomeIcon icon={faCircleNotch} spin /> : <FormattedMessage {...messages.exportToExcel} />}
        </Button>
      </ButtonContainer>
    </>
  );
}